import { Modal } from '@studiometa/ui';
import Cookies from 'js-cookie';

/**
 * AgeGate
 */
export default class AgeGate extends Modal {
  /**
   * Config
   */
  static config = {
    name: 'AgeGate',
  };

  /**
   * Mounted
   */
  mounted() {
    // Open modal if meta_agegate cookie isn't set
    if (Cookies.get('meta_agegate') !== 'true') {
      this.open();
    }
  }

  /**
   * close
   */
  close() {
    Cookies.set('meta_agegate', 'true', { expires: 0.1 });
    super.close();
  }

  /**
   * onOverlayClick
   * @returns {boolean}
   */
  onOverlayClick() {
    return false;
  }

  /**
   * Keyed
   * @param {*} props
   */
  keyed(props) {
    if (!props.ESC) {
      super.keyed(props);
    }
  }
}
